import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Building2, UserSquare2, User, Truck, Users, CalendarRange, CreditCard, Euro } from "lucide-react";
import { toast } from "sonner";

const fmt = (n) => (n ?? 0).toLocaleString("fr-FR");

const CARDS = [
  { key: "companies", label: "Sociétés (gérants)", icon: Building2, accent: "text-primary" },
  { key: "paying_companies", label: "Sociétés payantes", icon: CreditCard, accent: "text-green-600" },
  { key: "mrr_eur", label: "MRR estimé", icon: Euro, accent: "text-amber-600", suffix: " €" },
  { key: "etablissements", label: "Établissements", icon: UserSquare2, accent: "text-sky-600" },
  { key: "patients", label: "Patients", icon: User, accent: "text-purple-600" },
  { key: "fleet_drivers", label: "Conducteurs (flotte)", icon: Users, accent: "text-teal-600" },
  { key: "vehicles", label: "Véhicules", icon: Truck, accent: "text-rose-600" },
  { key: "rides", label: "Courses (total)", icon: CalendarRange, accent: "text-indigo-600" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Administration de la plateforme</h1>
        <p className="text-muted-foreground text-sm">Vue d'ensemble de toutes les sociétés et utilisateurs PACEMIA.</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map((c) => (
          <Card key={c.key} className="p-5 rounded-md shadow-none" data-testid={`admin-stat-${c.key}`}>
            <div className="flex items-center justify-between">
              <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{c.label}</p>
              <c.icon className={`h-5 w-5 ${c.accent}`} />
            </div>
            <p className="mt-3 font-display text-3xl font-extrabold tabular-nums">
              {stats ? `${fmt(stats[c.key])}${c.suffix || ""}` : "—"}
            </p>
          </Card>
        ))}
      </div>
    </div>
  );
}
